import React from 'react';
import { Box, Container, Grid, Typography, Button, Stack } from '@mui/material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import useMediaQuery from '@mui/material/useMediaQuery';

const WelcomeSection = () => {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    return (
        <Box sx={{ bgcolor: '#f1f1f1', }}>
            <Box sx={{ py: 10, maxWidth: '1200px', mx: 'auto', px: 2 }}>
                <Grid container spacing={10} alignItems="center">
                    {/* Left Side: Services Image */}
                    <Grid item xs={12} sm={6} md={6}>
                        <Box
                            component="img"
                            src={require('../assets/services-images.png')}
                            alt="4MH Enterprises Services"
                            sx={{
                                width: '100%',
                                height: 'auto',
                                display: 'block',
                            }}
                        />
                    </Grid>

                    {/* Right Side: Content */}
                    <Grid item xs={12} sm={6} md={6}>
                        {/* About Us Label */}
                        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                            <Box sx={{
                                display: 'inline-block',
                                width: 15,
                                height: 15,
                                bgcolor: '#5c9bd8',
                                border: '5px solid #d3dee4',
                                borderRadius: '15px',
                                mr: '9px'
                            }} />
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    color: '#25D5B2', // Teal color for text
                                    fontWeight: 500,
                                    textTransform: 'uppercase',
                                    letterSpacing: 1,
                                    fontSize: '14px'
                                }}
                            >
                                About Us
                            </Typography>
                        </Stack>

                        <Typography
                            variant="h3"
                            component="h2"
                            sx={{
                                fontWeight: 800,
                                color: '#212121',
                                mb: 2,
                                fontSize: { xs: '2rem', md: '3.2rem' },
                                lineHeight: 1.2,
                                width: { xs: '100%', md: 500 }
                            }}
                        >
                            Welcome to 4MH Enterprises
                        </Typography>

                        {/* Divider */}
                        <Box sx={{ width: 60, height: 4, bgcolor: '#25D5B2', mb: 3 }} />

                        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4, lineHeight: 1.8, fontSize: '15px', width: { xs: '100%', md: 550 } }}>
                            One of the most prestigious and recognized manufacturers, exporters,
                            supplier of diverse varieties of natural stones. Our hot products which we
                            manufacture on a very large scale are as follows...
                        </Typography>

                        <Button
                            variant="contained"
                            endIcon={<ArrowRightAltIcon />}
                            sx={{
                                bgcolor: '#25D5B2',
                                color: 'white',
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: '14px',
                                px: 4,
                                py: 1.5,
                                borderRadius: 0, // Sharp corners as per design (usually) or slight round
                                boxShadow: 'none',
                                '&:hover': {
                                    bgcolor: '#1fc2a1',
                                    boxShadow: 'none'
                                },
                            }}
                        >
                            Continue reading
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default WelcomeSection;
